var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    !_vm.complete
      ? _c(
          "div",
          [
            _vm._t("default"),
            _vm._v(" "),
            _c(
              "form",
              {
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.submitForm.apply(null, arguments)
                  },
                },
              },
              [
                _c("div", { staticClass: "border-t border-gray-200 mt-10" }, [
                  _c(
                    "div",
                    { staticClass: "lg:w-1/2 mt-10" },
                    [
                      _c(
                        "div",
                        { staticClass: "flex items-center mt-2" },
                        [
                          _c("form-toggle", {
                            model: {
                              value: _vm.form.terms,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "terms", $$v)
                              },
                              expression: "form.terms",
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "ml-2" }, [
                            _vm._v(
                              "\n                                I agree to the terms of the membership contract\n                            "
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.hasError("terms")
                        ? _c(
                            "div",
                            { staticClass: "ml-12 mt-1 text-xs text-red-600" },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.getErrorFor("terms")) +
                                  "\n                        "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("form-input", {
                        staticClass: "mt-6",
                        attrs: {
                          label: "Signed (Type Full Name)",
                          required: "",
                          error: _vm.getErrorFor("signed"),
                        },
                        model: {
                          value: _vm.form.signed,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "signed", $$v)
                          },
                          expression: "form.signed",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex justify-end mt-6" },
                        [
                          _c("form-button", { attrs: { type: "submit" } }, [
                            _vm._v(
                              "\n                                Sign Contract\n                            "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ],
          2
        )
      : _c("div", { staticClass: "space-y-6" }, [
          _c("p", [
            _vm._v(
              "\n                Thank you for completing your membership contract. Your Membership is now active and you can begin\n                making bookings.\n            "
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n                If you are paying monthly, please ensure you set up your Standing Order immediately using the banking\n                details provided in your email confirmation.\n            "
            ),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n                Please contact us on 01473 - 375 026 should you have any questions at all. We look forward to welcoming\n                you to your first event.\n            "
            ),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }